<template>
    <div class="warpper">
        <div class="bg-white padding-sm margin-bottom-sm">
            <div class="page-title line-height">聘书展示</div>
            <div class="classifys flex align-center">
                <router-link class="classify " to="/organization/setup/certificate">单位会员</router-link>
                <router-link class="classify " to="/organization/setup/scertificate">个人会员</router-link>
                <router-link class="classify active" to="/organization/setup/fcertificate">分会聘书</router-link>
            </div>
            <div class="certificate-bg">
                <img :src="demoUrl" alt="">
            </div>

        </div>
        <div class="bg-white padding-sm flex-sub">
            <div class="flex align-center justify-between margin-bottom-sm">
                <div class="page-title ">聘书模板 <span>定制设计模板请联系客服</span> <i>400-999-6541</i></div>
                <el-button class="yellow-btn" pr @click="saveCertificate">保存</el-button>
            </div>
            <div class="margin-bottom">
                <el-radio v-model="type" :label="1" border>使用默认模板</el-radio>
                <el-radio v-model="type" :label="2" border>上传自定义模板</el-radio>
            </div>
            <div v-if="type === 2" class="margin-bottom"> 聘书背景图要求：768像素*513像素，文件为：png/jpg，且不得大于5M</div>
            <div v-if="type === 2" class="flex justify-center">
                <el-upload
                    :action="baseURL + 'Admin/zhengshu/uploadPinShuBaseYuLan'"
                    :before-upload="beforeAvatarUpload"
                    :data="fileData"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    accept="image/*"
                    class="avatar-uploader">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <div v-else class="avatar-uploader-icon flex align-center justify-around">
                       <span> <i class="el-icon-plus"></i> <br>
                        点击上传聘书背景图预览 <br>
                        聘书背景图要求：768像素*513像素，文件为：png/jpg，且不得大于5M</span>
                    </div>
                </el-upload>
            </div>
        </div>

    </div>
</template>

<script>
import {savePinShuBase, getPinShuBase} from "@/api/organiz";
import {baseURL, IMAGE_PATH} from "@/config";
import {getToken} from "@/utils/utils";

export default {
    name: "certificate",
    data() {
        return {
            baseURL:baseURL,
            type: 1,
            demoUrl: '',    //  当前预览图
            imageUrl: '',   //  上传完成的预览图
            bgUrl: '',       //  上传完成的背景图
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        imgUrl() {
            return IMAGE_PATH
        },
        fileData() {
            return {...getToken(), ...{userType: 2}}
        }
    },
    created() {
        this.$emit('setIndex', [2, 5], '证书设置')
        this.getCertificate()
    },
    components: {},
    methods: {
        //  保存背景图
        async saveCertificate() {
            if (this.type === 2 && !this.bgUrl) return this.$message.error('请上传聘书背景图')
            let _state = await savePinShuBase(this.type, this.type === 2 ? this.bgUrl : '')
            if (_state.status === 200) {
                this.type = 1
                this.imageUrl = ''
                this.$message.success('更新成功')
                this.getCertificate()
            }
        },

        //  上传成功
        handleAvatarSuccess(file) {
            if (file.status === 200) {
                this.imageUrl = this.imgUrl + file.data.baseYuLanUrl
                this.bgUrl = file.data.baseUrl
            } else {
                this.$message.error(file.msg)
            }
        },
        //  上传前验证
        beforeAvatarUpload(file) {
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) this.$message.error('聘书背景图不能超过 5MB!');
            return isLt5M;
        },
        //  获取默认证书背景图
        async getCertificate() {
            let _data = await getPinShuBase()
            this.demoUrl = this.imgUrl + _data.data + '?v='+new Date().getTime()
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    .classifys {
        margin-top: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;

            color: #ffb400;

            &:first-child {
                border-radius: 6px 0 0 6px;
            }

            &:last-child {
                border-radius: 0 6px 6px 0;
            }

            &.active {
                background: #ffb400;
                color: #FFFFFF;
            }
        }
    }

    .certificate-bg {
        width: 828px;
        height: 583px;
        padding: 45px;
        margin: 30px auto;
        background: url(../../../../assets/img/certificate-bg.png) no-repeat center;
        background-size: 100% 100%;

        img {
            display: block;
            width: 728px;
            margin: 0 auto;
        }
    }

    .page-title {
        span {
            font-size: 16px;
            line-height: 45px;
            color: #999999;
            font-weight: normal;
        }

        i {
            display: inline-block;
            width: 106px;
            height: 18px;
            text-align: center;
            line-height: 18px;
            font-size: 14px;
            background-image: linear-gradient(37deg,
                #ffb400 0%,
                #fc7802 100%),
            linear-gradient(
                    #0a2240,
                    #0a2240);
            background-blend-mode: normal,
            normal;
            border-radius: 9px;
            color: #fff;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 18px;
        color: #8c939d;
        width: 768px;
        height: 513px;
        line-height: 40px;
        text-align: center;
        border: 1px dashed #d9d9d9;
    }

    .avatar {
        width: 768px;
        height: 513px;
        display: block;
    }
}
</style>
